import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 163700DD-5F95-4BEC-82AC-7E5F1FD20BC8
 * name view-week-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-week-outline.svg
 * tags
 * - View 
 */
export const ViewWeekOutlineIcon = createSvgIcon(<><path d="M21 4H3C2.45 4 2 4.45 2 5V19C2 19.55 2.45 20 3 20H21C21.55 20 22 19.55 22 19V5C22 4.45 21.55 4 21 4M8 18H4V6H8V18M14 18H10V6H14V18M20 18H16V6H20V18Z" /></>, 'ViewWeekOutlineIcon');
export default ViewWeekOutlineIcon